import { CommonOrderWorkType } from "./CommonOrderWorkType";

enum SpecificAgriculturalOrderWorkType {
    MOUNT = "MOUNT",
    WASH = "WASH",
}

export type AgriculturalContractorOrderWorkType = CommonOrderWorkType | SpecificAgriculturalOrderWorkType;
export const AgriculturalContractorOrderWorkType = { ...CommonOrderWorkType, ...SpecificAgriculturalOrderWorkType };
